import { defineStore } from "pinia";

export const useLiveStore = defineStore("live", {
    state: () => {
        return {
            link: "",
            style: "",
        };
    },
    actions: {},
});
